// src/resources/reports/ReportPushNotifications/export.ts
//
// Achata as mensagens enviadas numa linha por mensagem — mesmo espírito do
// penetrationExporter em ReportAppPenetration/export.ts, que também achata o
// grupo (posto × escopo) numa linha simples pra planilha.
import { formatNumber } from '../../../utils';
import { MessageRow, ORIGIN_LABELS, PushDetailsData } from './types';

const pct = (value: number | null): string =>
  value === null ? '' : formatNumber(value * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

const rowForMessage = (row: MessageRow) => ({
  mensagem: row.title,
  texto_push: row.pushMessage,
  tipo_de_envio: ORIGIN_LABELS[row.origin],
  disparos: row.dispatches,
  enviadas: row.sent,
  entregues: row.delivered,
  lidas: row.read,
  clicadas: row.clicked,
  // §5 do spec — mesma coluna nova da tabela, achatada pra planilha.
  aberturas_influenciadas: row.influencedOpens ?? 0,
  taxa_entrega: pct(row.deliveryRate),
  taxa_leitura: pct(row.readRate),
  taxa_clique: pct(row.clickRate),
  primeiro_envio: row.firstSentAt,
  ultimo_envio: row.lastSentAt,
});

// Assinatura solta (data: any[]) de propósito — mesmo padrão do
// penetrationExporter: o preExport do CustomExportButton tipa DataType como
// Record<string,string>, mas os relatórios existentes exportam número cru.
export const pushNotificationsExporter = async (data: any[]): Promise<any[]> => {
  const details = data?.[0] as PushDetailsData | undefined;
  if (!details) return [];

  return details.messages.map(rowForMessage);
};
